export enum RatingAspect {
  CLARITY = 'clarity',
  RESPONSIVENESS = 'responsiveness',
  TRANSPARENCY = 'transparency',
  UNDERSTANDING = 'understanding',
}

export enum ReviewDepth {
  BASIC = 'BASIC',
  DEEP_DIVE = 'DEEP_DIVE',
  STUB = 'STUB',
}

export enum ReviewFilter {
  CUSTOM = 'custom',
}

export enum ReviewSearchType {
  CUSTOM = 'custom',
  FOLLOWED = 'followed',
  LATEST = 'date',
  MINE = 'mine',
  OWNED_AND_FOLLOWED = 'ownedAndFollowed',
}

export enum ReviewStatus {
  ARCHIVED = 'ARCHIVED',
  COMPLETED = 'COMPLETED',
  DELETED = 'DELETED',
  IN_PROGRESS = 'IN_PROGRESS',
  NEEDS_EDITING = 'NEEDS_EDITING',
  PENDING_APPROVAL = 'PENDING_APPROVAL',
  REJECTED = 'REJECTED',
  STUB_COMPLETED = 'STUB_COMPLETED',
}

// TODO - NEED TO SHARE ENUMS FROM API

export enum ReviewStep {
  BASIC_REVIEW = 0,
  ENTRY_STRATEGY = 1,
  EVALUATION = 3,
  LEGAL = 4,
  NEGOTIATION = 5,
  PURCHASE_DETAILS = 2,
  RFP = 6,
}

export interface BaseReview {
  companyId?: number;
  companyName?: string;
  createdAt?: Date;
  dealArea?: string;
  dealDate?: string;
  favoriteCount?: number;
  id?: number;
  intelligenceRequestId?: number;
  isFavorite?: boolean;
  likeDislikeCount?: number;
  likePercentage?: number;
  ratings: Array<RatingSummary>;
  reviewDepth?: ReviewDepth;
  reviewType?: string;
  status: ReviewStatus;
  user?: ReviewUser;
  userId?: number;
  viewed?: boolean;
}

export interface BasicReview extends BaseReview {
  aiInvolved?: string;
  commentAdvice: string;
  commentBuyerBetter: string;
  commentBuyerWell: string;
  commentWinLose: string;
  // dealArea: string;
  dealClose: string;
  // dealDate?: string;
  dealLength: string;
  dealRfp?: string;
  dealSize: string;
  dealType: string;
  viewed?: boolean;
}

export type CurrentReview
  = | BasicReview
    | EntryStrategyReview
    | EvaluationReview
    | LegalReview
    | NegotiationReview
    | null
    | PurchaseDetailsReview
    | RfpReview;

export interface EntryStrategyReview extends BaseReview {
  adviceFirstStepComment?: string;
  avoidDoingComment?: string;
  breakthroughChannel?: string;
  breakthroughChannelOtherComment?: string;
  entryAttentionOtherComment?: string;
  entryAttentionSource?: string;
  externalProofLeverageComment?: string;
  outreachPainPointsComment?: string;
}

export interface EvaluationReview extends BaseReview {
  approversList?: string[];
  articulatingCriteriaComment?: string;
  buyerReplacingVendor?: string;
  criteriaArticulatedByBuyer?: string;
  criteriaArticulatedByBuyerComment?: string;
  criteriaChangeComment?: string;
  durationSecurityReview?: string;
  negotiateTrialComment?: string;
  noDecisionMakers?: string;
  platFormList?: string[];
  requireTrial?: string;
  roiJustificationKPIsComment?: string;
  securityDifficulty?: string;
  securityRequirementsComment?: string;
  submitRoi?: string;
  trialAccommodated?: string;
  trialLength?: string;
}

export interface FetchReviewsFiltersType {
  companyId?: number;
  dealArea?: string[];
  dealClose?: string;
  dealDate?: string;
  dealSize?: number[];
  dealSizeMax?: string;
  dealSizeMin?: string;
  dealType?: string[];
  dealWon?: string;
  searchType?: string;
}
export interface LegalReview extends BaseReview {
  autoRenewalClause?: string;
  customerAskLiability?: string;
  endAskLiability?: string;
  legalReviewDifficulty?: string;
  legalReviewLength?: string;
  liabilityComment?: string;
  liabilityStrategiesComment?: string;
  marketingPermission?: string;
  notableGenComment?: string;
  paperworkOption?: string;
}

export interface NegotiationReview extends BaseReview {
  competitiveBids?: string;
  discountGiven?: string;
  fairnessComment?: string;
  forcedTerminationAcceptance?: string;
  forcedTerminationAcceptanceComment?: string;
  fundsReleased?: string;
  negotiationTipsComment?: string;
  noticeHonored?: string;
  noticeSelection?: string;
  procurementFairness?: string;
  procurementTactics?: string;
  procurementThreshold?: string;
  procurementThresholdValue?: string;
  terminationConvenience?: string;
}

export interface PurchaseDetailsReview extends BaseReview {
  buyerFiscalYearEnd?: string;
  championEffectiveness?: string;
  championName?: string;
  definedBudget?: string;
  detractorExistence?: string;
  detractorResistanceComment?: string;
  detractorStrategiesComment?: string;
  detractorTitles?: string[];
  economicBuyerName?: string;
  paymentCycle?: string;
  salesCycleLength?: string;
}

export interface RatingSummary {
  name?: string;
  rating: number;
  type: string;
  user: string;
}

export interface ReviewMeta {
  hasMore: boolean;
  limit: number;
  offset: number;
  total: number;
}

export interface ReviewUser {
  avatarColor?: string;
  firstName?: string;
  id: number;
  lastName?: string;
  tagLine?: string;
  username?: string;
}

export interface RfpReview extends BaseReview {
  acceptanceFormatComment?: string;
  influenceRfpProcessComment?: string;
  rfpInfluence?: string;
  rfpInvolvement?: string;
  rfpLength?: string;
  rfpWin?: string;
  tipsComment?: string;
}
